export const formatDropdownNames = (internalName: string) => {
  if (internalName === null) {
    return "None";
  }

  const name = internalName?.toLowerCase()?.replace(/_/g, " ");

  switch (name) {
    case "json":
      return "JSON";
    case "json schema":
      return "JSON Schema";
    case "json object":
      return "JSON Object";
    case "text":
      return "Text";
    default:
      return name?.replace(/\b\w/g, char => char.toUpperCase());
  }
};

export const getParameterName = (name: string) =>
  name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());

const normalizValue = (name: string) => {
  if (name === null) {
    return "none";
  }

  return name.toLowerCase().replace(/[_\s]/g, " ").trim();
};

export const getParameterValue = (name: string) => {
  switch (normalizValue(name)) {
    case "json object":
      return { type: "json_object" };
    case "json schema":
      return { type: "json_schema" };
    case "none":
      return null;
    case "text":
      return { type: "text" };
    default:
      return name;
  }
};

export const getValue = (value: string | { type: string }) => {
  if (typeof value === "string") {
    return value;
  }

  if (value === null) {
    return "None";
  }

  return formatDropdownNames(value.type);
};
